import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { ReservationUsersSchema, type ReservationUsers } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

/**
 * Distinct users who completed a reservation + the reservations-per-user
 * distribution (from LAW `reservation_submitted` events keyed by accountId).
 */
export function useReservationUsers(range: TimeRange, options: UseMetricOptions = {}) {
  return useQuery<ReservationUsers>({
    queryKey: qk.metrics.reservationUsers(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/reservation-users?${toSearchParams(range).toString()}`,
        { signal },
      );
      return ReservationUsersSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
